import { IconShield, IconShieldCheck } from '@tabler/icons-react'
import { usePatient } from '@/hooks/usePatient'
import { formatDateTime } from '@/utils'
import { StatusPill } from './StatusPill'

type Props = {
  patientId: string | undefined
}

export function IdentityVerifiedBadge({ patientId }: Props) {
  const { data: patientData, loading } = usePatient(patientId)

  if (loading && !patientData) {
    return (
      <StatusPill color="gray" tooltip="Loading identity status…">
        Identity…
      </StatusPill>
    )
  }

  const verified = patientData?.identityVerified ?? false
  const verifiedAt = patientData?.identityVerifiedAt
  const verifiedBy = patientData?.identityVerifiedBy

  const tooltip = verified
    ? `Verified${verifiedBy ? ` by ${verifiedBy}` : ''}${
        verifiedAt ? ` on ${formatDateTime(verifiedAt, '/', true)}` : ''
      }`
    : 'Identity not verified. Portal access is limited to scheduling, intake, and insurance until a provider verifies the patient.'

  return (
    <StatusPill color={verified ? 'green' : 'gray'} tooltip={tooltip} multiline>
      {verified ? (
        <IconShieldCheck size={13} stroke={1.75} />
      ) : (
        <IconShield size={13} stroke={1.75} />
      )}
      <span>{verified ? 'Identity Verified' : 'Not Verified'}</span>
    </StatusPill>
  )
}
